import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { toast } from "react-toastify";
class PaymentFailure extends Component {
    state = {
        redirect: false
      }
    componentDidMount()
    {
        toast.error("Your Transaction is failed due to modified orderId!!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
          this.id = setTimeout(() => this.setState({ redirect: true }), 3000)
    }
    componentWillUnmount() {
        clearTimeout(this.id)
      }
    render() {
        // return (
        //     <div>
            // <br />
            // <br />
            // <br />
            // <br />
            // <section className="padding-default">aaaa</section>
        //     </div>
        // );
        return this.state.redirect
      ? <Redirect to="/" />
      : <div><br />
      <br />
      <br />
      <br />
      <section className="padding-default">You will be redirected automatically</section></div>
    }
}

export default PaymentFailure;